<template>
  <!-- Breadcrumb -->
  <v-row>
    <v-col cols="12">
      <v-breadcrumbs
        class="text-caption py-0 px-0"
        :items="viewModel.breadcrumbs"
      >
        <template v-slot:prepend>
          <v-icon icon="mdi-chart-bar" size="small"></v-icon>
        </template>
      </v-breadcrumbs>
    </v-col>
  </v-row>
  <v-row>
    <v-col cols="12">
      <!-- Vertical Tabs -->
      <v-card flat class="mb-4">
        <v-tabs
          v-model="viewModel.tab.value"
          color="primary"
          direction="horizontal"
          height="60"
          grow
        >
          <v-tab
            class="text-none"
            prepend-icon="mdi-hand-heart"
            text="Aportes"
            value="aportes"
          />
          <v-tab
            class="text-none"
            prepend-icon="mdi-wallet"
            text="Créditos"
            value="creditos"
          />
          <v-tab
            class="text-none"
            prepend-icon="mdi-circle-multiple"
            text="Ahorros"
            value="ahorros"
          />
        </v-tabs>
      </v-card>

      <!-- Tabs Window -->
      <v-tabs-window v-model="viewModel.tab.value" transition="none">
        <!-- Aportes Tab -->
        <v-tabs-window-item
          value="aportes"
          v-if="viewModel.tab.value === 'aportes'"
        >
          <v-text-field
            v-model="viewModel.searchAportes.value"
            label="Buscar Aportes"
            clear-icon="mdi-close-circle"
            variant="outlined"
            clearable
            density="compact"
            prepend-inner-icon="mdi-magnify"
            class="my-2"
            hide-details
            @click:clear="viewModel.clearSearchAportes"
          >
          </v-text-field>
          <v-card
            flat
            border
            class="pa-4 text-start rounded-sm overflow-y-auto"
            style="height: calc(100vh - 271px)"
            @scroll="(e) => handleScroll('aportes', e)"
          >
            <v-list>
              <v-card-subtitle v-if="viewModel.loading.value">
                <v-skeleton-loader
                  class="mx-4 my-2"
                  type="list-item-two-line"
                  v-for="n in 8"
                  :key="'skeleton-contribution-' + n"
                ></v-skeleton-loader>
              </v-card-subtitle>
              <v-list-item
                v-for="(transaction, index) in viewModel
                  .filteredContribTransactions.value"
                :key="index"
                class="pa-4 mb-2 border-b-sm"
                style="border-left: 7px solid rgb(var(--v-theme-primary), 0.4)"
              >
                <template #prepend>
                  <v-avatar
                    rounded="lg"
                    size="48"
                    variant="tonal"
                    :color="viewModel.getColor(transaction.tipomov)"
                  >
                    <v-icon size="20">{{
                      viewModel.getIconName(transaction.tipomov)
                    }}</v-icon>
                  </v-avatar>
                </template>
                <template #default>
                  <v-list-item-title class="text-subtitle-1 font-weight-bold">
                    {{ transaction.concepto }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-subtitle-2 py-1">
                    {{ transaction.fecha }} -
                    {{ transaction.hora }}
                  </v-list-item-subtitle>
                </template>

                <!-- Append Icon -->
                <template #append>
                  <v-list-item-subtitle
                    class="text-subtitle-1 font-weight-bold"
                    :class="`text-${viewModel.getColor(transaction.tipomov)}`"
                  >
                    <strong>
                      {{ viewModel.formatCoin(transaction.moneda) }}
                      {{ viewModel.formatFloat(transaction.saldo) }}
                    </strong>
                  </v-list-item-subtitle>
                </template>
              </v-list-item>
            </v-list>
            <v-alert
              v-if="!viewModel.filteredContribTransactions.value?.length"
              type="info"
              variant="tonal"
              class="text-center text-subtitle-2"
              border
              text="No hay movimientos de aportes para mostrar."
            >
            </v-alert>
          </v-card>
        </v-tabs-window-item>

        <!-- Créditos Tab -->
        <v-tabs-window-item
          value="creditos"
          v-if="viewModel.tab.value === 'creditos'"
        >
          <v-text-field
            v-model="viewModel.searchCreditos.value"
            label="Buscar Créditos"
            clear-icon="mdi-close-circle"
            variant="outlined"
            clearable
            density="compact"
            prepend-inner-icon="mdi-magnify"
            class="my-2"
            hide-details
            @click:clear="viewModel.clearSearchCreditos"
          ></v-text-field>
          <v-card
            flat
            border
            class="pa-4 text-start rounded-sm overflow-y-auto"
            style="height: calc(100vh - 271px)"
            @scroll="(e) => handleScroll('creditos', e)"
          >
            <v-list>
              <v-list-item
                v-for="(transaction, index) in viewModel
                  .filteredCreditTransactions.value"
                :key="index"
                class="pa-4 mb-2 border-b-sm"
                style="border-left: 7px solid rgb(var(--v-theme-primary), 0.4)"
              >
                <template #prepend>
                  <v-avatar
                    rounded="lg"
                    size="48"
                    variant="tonal"
                    :color="viewModel.getColor(transaction.tipomov)"
                  >
                    <v-icon size="20">{{
                      viewModel.getIconName(transaction.tipomov)
                    }}</v-icon>
                  </v-avatar>
                </template>
                <template #default>
                  <v-list-item-title class="text-subtitle-1 font-weight-bold">
                    {{ transaction.concepto }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-subtitle-2 py-1">
                    {{ transaction.fecha }} -
                    {{ transaction.hora }}
                  </v-list-item-subtitle>
                </template>

                <!-- Append Icon -->
                <template #append>
                  <v-list-item-subtitle
                    class="text-subtitle-1 font-weight-bold"
                    :class="`text-${viewModel.getColor(transaction.tipomov)}`"
                  >
                    <strong>
                      {{ viewModel.formatCoin(transaction.moneda) }}
                      {{ viewModel.formatFloat(transaction.saldo) }}
                    </strong>
                  </v-list-item-subtitle>
                </template>
              </v-list-item>
            </v-list>
            <v-alert
              v-if="!viewModel.filteredCreditTransactions.value.length"
              type="info"
              variant="tonal"
              class="text-center text-subtitle-2"
              border
              text="No hay movimientos de créditos para mostrar."
            >
            </v-alert>
          </v-card>
        </v-tabs-window-item>

        <!-- Ahorros Tab -->
        <v-tabs-window-item
          value="ahorros"
          v-if="viewModel.tab.value === 'ahorros'"
        >
          <v-text-field
            v-model="viewModel.searchAhorros.value"
            label="Buscar Ahorros"
            clear-icon="mdi-close-circle"
            variant="outlined"
            clearable
            density="compact"
            prepend-inner-icon="mdi-magnify"
            class="my-2"
            hide-details
            @click:clear="viewModel.clearSearchAhorros"
          ></v-text-field>
          <v-card
            flat
            border
            class="pa-4 text-start rounded-sm overflow-y-auto"
            style="height: calc(100vh - 271px)"
            @scroll="(e) => handleScroll('ahorros', e)"
          >
            <v-list>
              <v-list-item
                v-for="(transaction, index) in viewModel
                  .filteredSaverTransactions.value"
                :key="index"
                class="pa-4 mb-2 border-b-sm"
                style="border-left: 7px solid rgb(var(--v-theme-primary), 0.4)"
              >
                <template #prepend>
                  <v-avatar
                    rounded="lg"
                    size="48"
                    variant="tonal"
                    :color="viewModel.getColor(transaction.tipomov)"
                  >
                    <v-icon size="20">{{
                      viewModel.getIconName(transaction.tipomov)
                    }}</v-icon>
                  </v-avatar>
                </template>
                <template #default>
                  <v-list-item-title class="text-subtitle-1 font-weight-bold">
                    {{ transaction.concepto }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-subtitle-2 py-1">
                    {{ transaction.fecha }} -
                    {{ transaction.hora }}
                  </v-list-item-subtitle>
                </template>

                <!-- Append Icon -->
                <template #append>
                  <v-list-item-subtitle
                    class="text-subtitle-1 font-weight-bold"
                    :class="`text-${viewModel.getColor(transaction.tipomov)}`"
                  >
                    <strong>
                      {{ viewModel.formatCoin(transaction.moneda) }}
                      {{ viewModel.formatFloat(transaction.saldo) }}
                    </strong>
                  </v-list-item-subtitle>
                </template>
              </v-list-item>
            </v-list>
            <v-alert
              v-if="!viewModel.filteredSaverTransactions.value.length"
              type="info"
              variant="tonal"
              class="text-center text-subtitle-2"
              border
              text="No hay movimientos de ahorros para mostrar."
            >
            </v-alert>
          </v-card>
        </v-tabs-window-item>
      </v-tabs-window>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import TransactionViewModel from "@/viewmodels/app/TransactionViewModel";

// Create an instance of the ViewModel
const viewModel = new TransactionViewModel();

// Método para manejar el scroll
function handleScroll(tab: string, event: Event): void {
  const target = event.target as HTMLElement;

  if (target.scrollTop + target.clientHeight >= target.scrollHeight - 10) {
    if (tab === "aportes") {
      viewModel.loadMoreAportes();
    } else if (tab === "creditos") {
      viewModel.loadMoreCreditos();
    } else if (tab === "ahorros") {
      viewModel.loadMoreAhorros();
    }
  }
}
</script>

<style scoped></style>
